import { render, staticRenderFns } from "./Komfortbewirtschaftung.vue?vue&type=template&id=31dc00a6"
import script from "./Komfortbewirtschaftung.vue?vue&type=script&lang=js"
export * from "./Komfortbewirtschaftung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31dc00a6')) {
      api.createRecord('31dc00a6', component.options)
    } else {
      api.reload('31dc00a6', component.options)
    }
    module.hot.accept("./Komfortbewirtschaftung.vue?vue&type=template&id=31dc00a6", function () {
      api.rerender('31dc00a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Komfortbewirtschaftung.vue"
export default component.exports